import React from "react";
import PropTypes from "prop-types";
import { GoogleMap } from "@react-google-maps/api";

function Map(props) {
  const { center, setRef, children, ...rest } = props;

  return (
    <GoogleMap
      mapContainerStyle={{
        width: "100%",
        height: "100%",
      }}
      zoom={10}
      center={center}
      {...rest}
      onUnmount={() => setRef(null)}
      onLoad={(map) => setRef(map)}
      options={{
        streetViewControl: false,
        mapTypeControl: false,
        ...rest?.options,
      }}>
      {children}
    </GoogleMap>
  );
}

Map.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  setRef: PropTypes.func,
  children: PropTypes.node,
};

Map.defaultProps = {
  center: {
    lat: 19.4358394,
    lng: -99.131823,
  },
};

export default React.memo(Map);
